module.exports = "<div class=c-chart :class=\"{ 'c-chart--loading': !chart }\" ref=chart></div>";